<template>
  <div class="search-input-container" @click.stop>
    <div class="input-container">
      <input 
        ref="input" 
        type="text" 
        :placeholder="placeholder" 
        v-model.trim="searchText" 
        @input="searchTermsRecommend" 
        @focus="onSearchInputFocus()" 
        @keypress.enter="onInputSearch()"
        @keyup.up="onKeyUp"
        @keyup.down="onKeyDown"
      />
      <el-button class="search-button"><i class="icon-search"></i></el-button>
    </div>
    <div v-if="!searchText&&suggestionList.length&&isSuggestionPanelActive" class="history-container">
      <div class="history-title">最近搜索</div>
      <ul class="suggestion-list" :class="[{ active: !searchText&&isSuggestionPanelActive && suggestionList.length}]" @mouseover="onHistoryMouseOver" @mouseout="isOnHistoryMouseOver = false">
        <li 
          class="suggestion-item"
          :class="{'checked-suggestion-item': checkedHistoryCompanyName && item.searchText === checkedHistoryCompanyName.searchText}" 
          v-for="item in suggestionList" 
          :key="item.index" 
          @click="onSuggestionHistoryItemClick(item)">
          <a class="item-value">{{item.searchText}}</a>
        </li>
      </ul>
    </div>
    <div v-if="searchText&&isSuggestionPanelActive&&isShowNoDate&&(recommendWordList.length || recommendPerson.length || recommendOther.length)" class="history-container">
      
      <div v-if="recommendPerson.length" @mouseover="onMouseOver" @mouseout="isOnMouseOver = false">
        <div class="history-title">人物</div>
        <ul class="suggestion-list" :class="[{ active: isSuggestionPanelActive&&recommendPerson.length&&searchText}]">
          <li 
            class="suggestion-item" 
            :class="{'checked-suggestion-item': checkedCompanyName && item.person_name === checkedCompanyName.person_name}"
            v-for="item in recommendPerson" 
            :key="item.index" 
            @click="onSuggestionItemClick(item.person_name, 'person')" 
          >
            <a class="item-value">{{item.person_name}}</a>
            <img @click.stop="toCompanyPage(item.id)" v-if="showArrow" class="img" src="../../assets/img/arrow1.svg" alt="">
          </li>
        </ul>
        <div class="hr-container">
          <div class="hr"></div>
        </div>
      </div>

      <div v-if="recommendWordList.length" @mouseover="onMouseOver" @mouseout="isOnMouseOver = false">
        <div class="history-title">公司</div>
        <ul class="suggestion-list" :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&searchText}]">
          <li 
            class="suggestion-item" 
            :class="{'checked-suggestion-item': checkedCompanyName && item.name === checkedCompanyName.name}"
            v-for="item in recommendWordList" 
            :key="item.index" 
            @click="onSuggestionItemClick(item.id, 'company')" 
            >
            <a class="item-value">{{item.name}}</a>
            <img @click.stop="toCompanyPage(item.id)" v-if="showArrow" class="img" src="../../assets/img/arrow1.svg" alt="">
          </li>
        </ul>
        <div class="hr-container">
          <div class="hr"></div>
        </div>
      </div>
      <div>
        <div class="related-news" :class="{'checked-related-news': this.checkedCompanyName && this.checkedCompanyName.name === '搜索相关公司'}" @click="onSearch()">
          <div class="related-news-word">
            "{{searchText}}"的相关新闻
          </div>
        </div>
      </div>
    </div>
     <div v-if="searchText&&isSuggestionPanelActive&&isShowNoDate&&!recommendWordList.length&&!recommendPerson.length&&!recommendOther.length" class="history-container">
      <div class="none-title">没有相关公司</div>
      <div class="hr-container">
          <div class="hr"></div>
      </div>
      <div>
        <div class="related-news" :class="{'checked-related-news': this.checkedCompanyName && this.checkedCompanyName.name === '搜索相关公司'}" @click="onSearch()">
          <div class="related-news-word">
            "{{searchText}}"的相关新闻
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrayHelper from '@/helpers/arrayHelper';
import funcHelper from '@/helpers/funcHelper';
import searchHistoryHelper from '@/helpers/searchHistoryHelper';
import QuestionQuery from '@/rest/questionQuery';

const MAX_SUGGESTION_COUNT = 5;

export default {
  name: 'search-input', 
  props: {
    keyword: String,
    showArrow: Boolean
  },
  data() {
    return {
      exactlyMatchStatus: false,
      active: 'active',
      placeholder: '搜人物/公司/新闻',
      isSuggestionPanelActive: false,
      searchText: undefined, // used to first time initialization
      historySuggestionList: [], // used to display on the UI
      historySuggestionSet: [], // used to store the whole suggestion list, support maximum 100: TODO
      suggestionList: [],
      recommendWordList: [],
      recommendPerson: [],
      recommendIssuance: [],
      recommendOther: [],
      timer: null,
      isShowNoDate: false,
      checkedHistoryCompanyName: null,
      checkedHistoryCompanyNameIndex: -1,
      checkedCompanyName: null,
      checkedCompanyNameIndex: -1,
      checkedPersonIndex: -1,
      isOnMouseOver: false,
      isOnHistoryMouseOver: false
    };
  },
  methods: {
    onMouseOver() {
      this.checkedCompanyName = null;
      this.checkedCompanyNameIndex = -1;
      this.isOnMouseOver = true;
    },
    onHistoryMouseOver() {
      this.checkedHistoryCompanyName = null;
      this.checkedHistoryCompanyNameIndex = -1;
      this.isOnHistoryMouseOver = true;
    },
    onKeyUp() {
      if (!this.isOnMouseOver && !this.isOnHistoryMouseOver) {
        if (!this.searchText) {
          if (!this.checkedHistoryCompanyNameIndex || this.checkedHistoryCompanyNameIndex === -1) {
            this.checkedHistoryCompanyNameIndex = this.suggestionList.length - 1;
          } else {
            this.checkedHistoryCompanyNameIndex--;
          }
          this.checkedHistoryCompanyName = this.suggestionList[this.checkedHistoryCompanyNameIndex];
        } else {
          // eslint-disable-next-line
          if (this.recommendPerson.length && this.recommendWordList.length) {
            if (this.checkedPersonIndex === -1 && this.checkedCompanyNameIndex === -1) {
              this.checkedCompanyNameIndex = this.recommendWordList.length;
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
              this.checkedPersonIndex = -1;
            } else if (!this.checkedPersonIndex && this.checkedCompanyNameIndex === -1) {
              this.checkedCompanyNameIndex = this.recommendWordList.length;
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
              this.checkedPersonIndex = -1;
            } else if (this.checkedPersonIndex === -1 && !this.checkedCompanyNameIndex) {
              this.checkedPersonIndex = this.recommendPerson.length - 1;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
              this.checkedCompanyNameIndex = -1;
            } else if (this.checkedPersonIndex === -1 && this.checkedCompanyNameIndex !== -1) {
              this.checkedCompanyNameIndex--;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            } else if (this.checkedPersonIndex !== -1 && this.checkedCompanyNameIndex === -1) {
              this.checkedPersonIndex--;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            }
          } else if (this.recommendPerson.length && !this.recommendWordList.length) {
            if (!this.checkedPersonIndex || this.checkedPersonIndex === -1) {
              this.checkedPersonIndex = this.recommendPerson.length;
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
            } else {
              this.checkedPersonIndex--;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            }
          } else if (!this.recommendPerson.length && this.recommendWordList.length) {
            if (!this.checkedCompanyNameIndex || this.checkedCompanyNameIndex === -1) {
              this.checkedCompanyNameIndex = this.recommendWordList.length;
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
            } else {
              this.checkedCompanyNameIndex--;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            }
          } else {
            this.checkedCompanyName = {
              id: '搜索相关公司',
              name: '搜索相关公司'
            };
          }
        }
      }
    },
    onKeyDown() {
      if (!this.isOnMouseOver && !this.isOnHistoryMouseOver) {
        if (!this.searchText) {
          if (this.checkedHistoryCompanyNameIndex === this.suggestionList.length - 1) {
            this.checkedHistoryCompanyNameIndex = 0;
          } else {
            this.checkedHistoryCompanyNameIndex++;
          }
          this.checkedHistoryCompanyName = this.suggestionList[this.checkedHistoryCompanyNameIndex];
        } else {
          // eslint-disable-next-line
          if (this.recommendPerson.length && this.recommendWordList.length) {
            if (this.checkedPersonIndex === -1 && this.checkedCompanyNameIndex === -1) {
              this.checkedPersonIndex++;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            } else if (this.checkedPersonIndex === this.recommendPerson.length - 1 && this.checkedCompanyNameIndex === -1 && this.checkedPersonIndex !== -1) {
              this.checkedPersonIndex = -1;
              this.checkedCompanyNameIndex++;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            } else if (this.checkedCompanyNameIndex === -1 && this.checkedPersonIndex !== -1) {
              this.checkedPersonIndex++;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            } else if (this.checkedCompanyNameIndex === this.recommendWordList.length - 1 && this.checkedCompanyNameIndex !== -1 && this.checkedPersonIndex === -1) {
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
              this.checkedCompanyNameIndex++;
            } else if (this.checkedCompanyNameIndex === this.recommendWordList.length && this.checkedCompanyNameIndex !== -1 && this.checkedPersonIndex === -1) {
              this.checkedCompanyNameIndex = -1;
              this.checkedPersonIndex++;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            } else if (this.checkedCompanyNameIndex !== -1 && this.checkedPersonIndex === -1) {
              this.checkedCompanyNameIndex++;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            }
          } else if (this.recommendPerson.length && !this.recommendWordList.length) {
            if (this.checkedPersonIndex === this.recommendPerson.length - 1) {
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
              this.checkedPersonIndex++;
            } else if (this.checkedPersonIndex === this.recommendPerson.length) {
              this.checkedPersonIndex = 0;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            } else {
              this.checkedPersonIndex++;
              this.checkedCompanyName = this.recommendPerson[this.checkedPersonIndex];
            }
          } else if (!this.recommendPerson.length && this.recommendWordList.length) {
            if (this.checkedCompanyNameIndex === this.recommendWordList.length - 1) {
              this.checkedCompanyName = {
                id: '搜索相关公司',
                name: '搜索相关公司'
              };
              this.checkedCompanyNameIndex++;
            } else if (this.checkedCompanyNameIndex === this.recommendWordList.length) {
              this.checkedCompanyNameIndex = 0;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            } else {
              this.checkedCompanyNameIndex++;
              this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
            }
          } else {
            this.checkedCompanyName = {
              id: '搜索相关公司',
              name: '搜索相关公司'
            };
          }
        }
      }
    },
    searchTermsRecommend() {
      this.isShowNoDate = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.searchText) {
          this.getSearchTextRecommend();
        }
      }, 300);
    },
    async getSearchTextRecommend() {
      const oldSearchText = this.searchText;
      const res = await QuestionQuery.searchTextRecommend(encodeURIComponent(this.searchText));
      this.checkedCompanyNameIndex = -1;
      this.checkedPersonIndex = -1;
      if (this.searchText === oldSearchText) {
        this.recommendPerson = res.person.slice(0, 3);
        this.recommendWordList = res.company.slice(0, 10 - this.recommendPerson.length);
        if (this.searchText === '光大科技') {
          [this.recommendWordList[0], this.recommendWordList[1]] = [this.recommendWordList[1], this.recommendWordList[0]];
        }
        this.isSuggestionPanelActive = true;
        this.isShowNoDate = true;
        this.checkedCompanyNameIndex = -1;
        this.checkedCompanyName = null;
      }
    },
    onSearchInputFocus() {
      if (!this.searchText) {
        this.checkedHistoryCompanyNameIndex = -1;
        this.checkedHistoryCompanyName = null;
      }
      this.isSuggestionPanelActive = true;
      this.$emit('onFocus', true);
    },
    onSearchInputBlur() {
      this.isSuggestionPanelActive = false;
      this.$emit('onFocus', false);
    },
    onSuggestionItemClick(text, type) {
      this.searchText = text;
      if (type === 'company') {
        this.addToHistorySuggestionList({ searchText: text, type: 'company' });
        this.$emit('change', { searchText: this.searchText, type: 'company' }); 
      } else if (type === 'person') {
        this.addToHistorySuggestionList({ searchText: text, type: 'person' });
        this.$emit('change', { searchText: this.searchText, type: 'person' }); 
      }
      this.$refs.input.blur();
      this.onSearchInputBlur();
      this.searchText = '';
    },
    onSuggestionHistoryItemClick(text) {
      if (this.suggestionList.indexOf(text) > -1) {
        if (this.suggestionList[this.suggestionList.indexOf(text)].type === 'company') {
          this.$emit('change', { searchText: text.searchText, type: 'company' });
        } else if (this.suggestionList[this.suggestionList.indexOf(text)].type === 'person') {
          this.$emit('change', { searchText: text.searchText, type: 'person' });
        } else if (this.suggestionList[this.suggestionList.indexOf(text)].type === 'search') {
          this.$emit('searchCompany', text.searchText);
        }
      }
      this.onSearchInputBlur();
    },
    onSearch() {
      this.isSuggestionPanelActive = false;
      this.addToHistorySuggestionList({ searchText: this.searchText, type: 'search' });
      this.$emit('searchCompany', this.searchText);
      this.searchText = '';
    },
    onInputSearch() {
      if (this.searchText) {
        if (!this.checkedCompanyName) {
          QuestionQuery.searchTextRecommend(encodeURIComponent(this.searchText)).then(res => {
            this.recommendPerson = res.person.slice(0, 3);
            this.recommendWordList = res.company.slice(0, 10 - this.recommendPerson.length);
            if (this.searchText === '光大科技') {
              this.recommendWordList[0].exactlyMatch = false;
              this.recommendWordList[1].exactlyMatch = true;
              [this.recommendWordList[0], this.recommendWordList[1]] = [this.recommendWordList[1], this.recommendWordList[0]];
            }
            this.isShowNoDate = true;

            this.recommendPerson.forEach(item => {
              if (item.exactlyMatch) {
                this.onSuggestionItemClick(item.person_name, 'person');
                this.exactlyMatchStatus = true;
              }
            });
            this.recommendWordList.forEach(item => {
              if (item.exactlyMatch) {
                this.onSuggestionItemClick(item.id, 'company');
                this.exactlyMatchStatus = true;
              }
            });
            
            if (!this.exactlyMatchStatus) {
              this.addToHistorySuggestionList({ searchText: this.searchText, type: 'search' });
              this.isSuggestionPanelActive = false;
              this.$refs.input.blur(); 
              this.$emit('searchCompany', this.searchText);
              this.searchText = '';
            }
            this.exactlyMatchStatus = false;
          });
        } else if (this.checkedCompanyName.name === '搜索相关公司') {
          this.onSearch();
          this.checkedCompanyNameIndex = -1;
          this.checkedCompanyName = null;
        } else if (this.checkedPersonIndex !== -1 && this.checkedCompanyNameIndex === -1) {
          this.onSuggestionItemClick(this.checkedCompanyName.person_name, 'person');
          this.checkedCompanyNameIndex = -1;
          this.checkedCompanyName = null;
        } else if (this.checkedPersonIndex === -1 && this.checkedCompanyNameIndex !== -1) {
          this.onSuggestionItemClick(this.checkedCompanyName.id, 'company');
          this.checkedCompanyNameIndex = -1;
          this.checkedCompanyName = null;
        }
      } else {
        this.onSuggestionHistoryItemClick(this.checkedHistoryCompanyName);
        this.checkedHistoryCompanyNameIndex = -1;
        this.checkedHistoryCompanyName = null;
      }
    },
    toCompanyPage(res) {
      this.addToHistorySuggestionList({ searchText: res, type: 'company' });
      this.isSuggestionPanelActive = false;
      this.$refs.input.blur();
      this.$emit('arrowSearchCompany', res);
    },
    addToHistorySuggestionList(searchText) {
      if (searchText) {
        searchHistoryHelper.add(searchText);
      }
    },
    searchTextChangeHandler(val) {
      this.historySuggestionList = this.filterHistorySuggestionList(val);
      this.suggestionList = this.historySuggestionList;
    },
    filterHistorySuggestionList(query) {
      query = query || '';
      this.historySuggestionSet = searchHistoryHelper.getAll();
      const tmpSuggestionList = this.historySuggestionSet.filter((item) => item.searchText && item.searchText.indexOf(query.toLocaleLowerCase()) > -1); 
      return arrayHelper.takeFirstNElements(tmpSuggestionList, MAX_SUGGESTION_COUNT);    
    }
  },
  mounted() {
    document.addEventListener('click', this.onSearchInputBlur);
    this.searchText = this.keyword || undefined;// to set the same value as it's just mounted
    this.historySuggestionSet = searchHistoryHelper.getAll();
    this.searchTextChangeHandler(this.searchText);
    this.debouncedSearchTextChangeHandler = funcHelper.debounce(this.searchTextChangeHandler, 500);
  },
  beforeDestroy() {
    // un-register events
    if (this.isSuggestionPanelActive) {
      this.onSearchInputBlur();
    }
    document.removeEventListener('click', this.onSearchInputBlur);
  },
  watch: {
    keyword(val) {
      this.searchText = val || '';
    }
  }
};
</script>

<style lang="scss" scoped>
$backgroundColor: #f7f8fc;
$hoverColor: #423f43;
$activeColor: #5f5d60;
$color: #9ea1b4;

$listItemHoverColor: #f3f3f3;
$listItemTextColor: #333333;

.search-input-container{
  height: 34px;
  position: relative;
  
  .input-container {
    position: relative;
    width: 100%;
    input {
      width: 100%;
      height: 26px;
      margin-top: -6px;
      padding: 10px 50px 10px 12px;
      font-size: 14px;
      border: solid 2px $backgroundColor;
      border-radius: 2px;
      background-color: $backgroundColor;
      outline: none;
    }
    input::-webkit-input-placeholder{
      color: $color;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color: $color;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color: $color;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color: $color;
    }

    .search-button { 
      position: absolute;
      top: 3px;
      right: 2px;     
      padding: 0px 12px;
      width: 46px;
      background-color: $backgroundColor;
      border: none;
      cursor: auto;
      span {
        display: block;
      }

      .icon-search {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url('../../assets/img/search3.svg');
        background-size: 100% 100%;
      }
    }
  } 

  .history-container {      
    position: absolute;  
    margin-top: 2px;
    padding: 16px 0 12px;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 1px #f7f7fa;
    border-radius: 2px;  
    z-index: 1000;

    .suggestion-list {      
      margin: 0;
      padding-left: 0;
      font-size: 14px;
      list-style: none;
      li {
        display: flex;
        justify-content: space-between;
        padding-left: 12px;        
        color: #464d6c; 
        cursor: pointer;

        &:hover {
          background-color: #45a8cc;
          color: #ffffff;
        }

        .item-value {
          overflow: hidden;
          display: inline-block;
          width: 580px;
          height: 28px;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 28px;
        }
        .img {
          margin: 8px 16px 0 0;
          width: 16px;
          height: 16px;
          opacity: 0.2;
          &:hover {
            opacity: 1;
          }
        }
      }
      .checked-suggestion-item {
        background-color: #45a8cc;
        color: #ffffff;
      }
    }

    .history-title {
      padding-left: 12px;
      padding-bottom: 4px;
      font-size: 12px;
      color: #45a8cc;
    }
    .none-title{
      padding-left: 12px;
      font-size: 12px;
      line-height: 28px;
      color: #9ea1b4;
    }
    .hr-container {
      padding: 8px 16px;
      .hr {
        height: 1px;
        background-color: #d8d8d8;
        opacity: 0.1;
      }
    }
  }
    .related-news {
      height: 32px;
      line-height: 32px;
      color: #464d6c;
      background-color: #ffffff !important;
      font-size: 14px; 
      cursor: pointer;
      .related-news-word {
        padding-left: 12px;
      }
      &:hover {
        background-color: #45a8cc !important;
        color: #ffffff;
      }
    }
    .checked-related-news {
      background-color: #45a8cc !important;
      color: #ffffff;
    }
}
</style>
